import { Component, OnInit } from '@angular/core';
import {NavService} from '../../../_services/_nav.service';
import {ActivatedRoute, Params} from '@angular/router';
import {Location} from '@angular/common';
import {ConvenioPlanCargo} from '../../../_models/convenio-plan-cargo';
import {forkJoin} from 'rxjs';
import {ConveniosConceptosService} from '../../../_services/convenios-conceptos.service';

@Component({
  selector: 'app-convenios-plan-cargos-detalle',
  templateUrl: './convenios-plan-cargos-detalle.component.html',
  styleUrls: ['./convenios-plan-cargos-detalle.component.css']
})
export class ConveniosPlanCargosDetalleComponent implements OnInit {

  conveniosPlanPagos: ConvenioPlanCargo;
  carInformacionInicial = true;

  constructor(
    private navServicio: NavService,
    private route: ActivatedRoute,
    private location: Location,
    private convenioPlanCargoService: ConveniosConceptosService,
  ) { }

  ngOnInit() {
    this.route.params.subscribe((params: Params) => {
      forkJoin(this.convenioPlanCargoService.obtenerPorId(params['id'])).subscribe(async ([pagaduria]) => {
        this.conveniosPlanPagos = pagaduria;
        this.carInformacionInicial = false;
      });
    });
  }

  regresar() {
    this.location.back();
  }

}
